export default "__VITE_ASSET__EQe5V4vE__"